// import React, { useState } from "react";

// import { useNavigate } from "react-router-dom";
// import { FiArrowRight } from "react-icons/fi";

// const servicesData = [
//   {
//     id: 1,
//     title: "PPI Business",
//     subtitle: "State Wallet Infrastructure",
//     description: "Launch and manage scalable prepaid instruments with integrated issuance, IMPS rails, hosting, and regulatory compliance.",
//     image: "/assets/images/headerimg.png",
//     path: "/citizen-wallet",
//     gradient: "linear-gradient(135deg, #14532d 0%, #064e3b 100%)",
//     shortTitle: "PPI Business"
//   },
//   {
//     id: 2,
//     title: "Payment Aggregation Services",
//     subtitle: "High-Performance Aggregation",
//     description: "Drive merchant growth with secure transactions, wallet integrations, and real-time settlement.",
//     image: "/assets/images/image (14).png",
//     path: "/tapay",
//     gradient: "linear-gradient(135deg, #1e3a8a 0%, #172554 100%)",
//     shortTitle: "Payment Aggregation"
//   },
//   {
//     id: 3,
//     title: "BBPS Business",
//     subtitle: "Enterprise Bill Payments",
//     description: "Scalable bill payment processing across multiple categories with an RBI-compliant framework and automated reconciliation.",
//     image: "/assets/images/bbpsimage2.png",
//     path: "/bbps-services",
//     gradient: "linear-gradient(135deg, #0f766e 0%, #042f2e 100%)",
//     shortTitle: "BBPS Business"
//   },
//   {
//     id: 4,
//     title: "Onboarding Stack",
//     subtitle: "Intelligent Client Automation",
//     description: "Digitize KYC, automate verifications, and activate customers faster with a fully compliant onboarding ecosystem.",
//     image: "assets/onboardingimg.png",
//     path: "/onboarding-stack",
//     gradient: "linear-gradient(135deg, #334155 0%, #0f172a 100%)",
//     shortTitle: "Onboarding Stack"
//   }
// ];

// const ExpandingHero = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const navigate = useNavigate();

//   return (
//     <div className="expanding-hero-root">
//       <style>
//         {`
//           .expanding-hero-root {
//             padding: 40px 20px;
//             font-family: 'Inter', -apple-system, sans-serif;
//             overflow: hidden;
//             background-color: transparent;
//           }

//           .gallery-container {
//             display: flex;
//             width: 100%;
//             max-width: 1400px;
//             height: 500px;
//             gap: 16px;
//             margin: 0 auto;
//           }

//           /* --- Main Panel Logic --- */
//           .gallery-panel {
//             position: relative;
//             flex: 0.7; /* Small when collapsed */
//             border-radius: 24px;
//             overflow: hidden;
//             cursor: pointer;
//             transition: flex 0.8s cubic-bezier(0.25, 1, 0.3, 1), transform 0.3s ease;
//             display: flex;
//             background-size: cover;
//           }

//           .gallery-panel:hover:not(.active) {
//             transform: translateY(-4px);
//           }

//           .gallery-panel.active {
//             flex: 5; /* Expands to give text and grid breathing room */
//             cursor: default;
//           }

//           /* --- Desktop Grid Layout (Text Left / Image Right) --- */
//           .panel-grid {
//             display: grid;
//             grid-template-columns: 1.1fr 0.9fr; 
//             width: 100%;
//             height: 100%;
//             padding: 60px;
//             opacity: 0;
//             pointer-events: none;
//             transition: opacity 0.4s ease;
//             z-index: 10;
//           }

//           .gallery-panel.active .panel-grid {
//             opacity: 1;
//             pointer-events: auto;
//             transition-delay: 0.25s;
//           }

//           /* --- Left Side Content --- */
//           .content-left {
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: flex-start;
//           }

//           .content-left h4 {
//             color: #4ade80;
//             text-transform: uppercase;
//             letter-spacing: 1.5px;
//             font-weight: 700;
//             font-size: 0.85rem;
//             margin: 0 0 12px 0;
//           }

//           .content-left h2 {
//             font-size: clamp(1.8rem, 3vw, 2.8rem);
//             color: #ffffff;
//             font-weight: 800;
//             line-height: 1.2;
//             margin: 0 0 20px 0;
//           }

//           .content-left p {
//             font-size: 1.05rem;
//             color: rgba(255, 255, 255, 0.85);
//             line-height: 1.6;
//             margin: 0 0 32px 0;
//             max-width: 90%;
//           }

//           /* --- Right Side Content --- */
//           .content-right {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             position: relative;
//           }

//           .service-img {
//             max-width: 100%;
//             max-height: 85%;
//             object-fit: contain;
//             filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.35));
//             transform: scale(0.95);
//             transition: transform 0.8s cubic-bezier(0.25, 1, 0.3, 1);
//           }

//           .gallery-panel.active .service-img {
//             transform: scale(1.05);
//           }

//           /* --- Action Button --- */
//           .explore-btn {
//             background: #ffffff;
//             color: #0f172a;
//             border: none;
//             padding: 14px 28px;
//             border-radius: 12px;
//             font-weight: 700;
//             font-size: 0.95rem;
//             display: inline-flex;
//             align-items: center;
//             gap: 10px;
//             cursor: pointer;
//             transition: all 0.3s ease;
//             box-shadow: 0 4px 12px rgba(0,0,0,0.1);
//           }

//           .explore-btn:hover {
//             transform: translateX(4px);
//             background: #f8fafc;
//             color: #000000;
//           }

//           /* --- Vertical Text Layout for Collapsed Cards --- */
//           .collapsed-title {
//             position: absolute;
//             inset: 0;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             z-index: 5;
//             transition: opacity 0.2s;
//           }

//           .collapsed-title span {
//             transform: rotate(-90deg);
//             white-space: nowrap;
//             color: rgba(255, 255, 255, 0.65);
//             font-weight: 700;
//             font-size: 0.9rem;
//             text-transform: uppercase;
//             letter-spacing: 3px;
//           }

//           .gallery-panel.active .collapsed-title {
//             opacity: 0;
//             pointer-events: none;
//           }

//           /* ==========================================================================
//              MOBILE & TABLET RESPONSIVE RE-ENGINEERING
//              ========================================================================== */
//           @media (max-width: 960px) {
//             .expanding-hero-root {
//               padding: 24px 16px;
//             }

//             .gallery-container {
//               flex-direction: column;
//               height: auto; /* Dynamic height calculation on mobile devices */
//               gap: 12px;
//             }

//             .gallery-panel {
//               flex: none !important; /* Disables flex horizontal expansion mechanics */
//               width: 100%;
//               height: 72px; /* Uniform flat collapsed state row height */
//               border-radius: 16px;
//               transition: height 0.6s cubic-bezier(0.25, 1, 0.3, 1);
//             }

//             .gallery-panel.active {
//               height: auto; /* Allow active items to grow organically based on text content */
//             }

//             /* --- Flatten Collapsed row title safely --- */
//             .collapsed-title {
//               justify-content: flex-start;
//               padding: 0 24px;
//             }

//             .collapsed-title span {
//               transform: none; /* Reset rotation for safe mobile view */
//               color: #ffffff;
//               font-size: 1rem;
//               letter-spacing: 1px;
//             }

//             /* --- Stack Layout components on Mobile --- */
//             .panel-grid {
//               grid-template-columns: 1fr; /* Switch grid to single file system */
//               padding: 32px 24px;
//               gap: 24px;
//             }

//             /* Header pushes down when open on mobile to make room for dynamic form layout */
//             .gallery-panel.active .panel-grid {
//               display: flex;
//               flex-direction: column;
//             }

//             .content-left {
//               align-items: flex-start;
//               text-align: left;
//             }

//             .content-left h4 {
//               font-size: 0.8rem;
//               margin-bottom: 8px;
//             }

//             .content-left h2 {
//               font-size: 1.75rem;
//               margin-bottom: 14px;
//             }

//             .content-left p {
//               font-size: 0.95rem;
//               max-width: 100%;
//               margin-bottom: 24px;
//               line-height: 1.5;
//             }

//             .explore-btn {
//               width: 100%; /* Call to Action buttons take up full width for easy user tapping */
//               justify-content: center;
//               padding: 16px;
//             }

//             .content-right {
//               margin-top: 8px;
//               width: 100%;
//             }

//             .service-img {
//               max-height: 180px;
//               width: auto;
//               transform: scale(1) !important; /* Disables problematic multi-scale properties */
//             }
//           }
//         `}
//       </style>

//       <div className="gallery-container">
//         {servicesData.map((service, index) => (
//           <div
//             key={service.id}
//             className={`gallery-panel ${activeIndex === index ? "active" : ""}`}
//             style={{ background: service.gradient }}
//             onMouseEnter={() => {
//               if (window.innerWidth > 960) setActiveIndex(index);
//             }}
//             onClick={() => {
//               if (activeIndex !== index) {
//                 setActiveIndex(index);
//               } else {
//                 navigate(service.path);
//               }
//             }}
//           >
//             {/* Displayed when card is NOT active */}
//             <div className="collapsed-title">
//               <span>{service.shortTitle}</span>
//             </div>

//             {/* Displayed when card IS active (Split Layout Grid) */}
//             <div className="panel-grid">
//               <div className="content-left">
//                 <h4>{service.subtitle}</h4>
//                 <h2>{service.title}</h2>
//                 <p>{service.description}</p>
//                 <button
//                   className="explore-btn"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     navigate(service.path);
//                   }}
//                 >
//                   Get Started <FiArrowRight size={18} />
//                 </button>
//               </div>

//               <div className="content-right">
//                 <img
//                   src={service.image}
//                   alt={service.title}
//                   className="service-img"
//                 />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ExpandingHero;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

const servicesData = [
  {
    id: 1,
    title: "PPI Business",
    subtitle: "State Wallet Infrastructure",
    description: "Launch and manage scalable prepaid instruments with integrated issuance, IMPS rails, hosting, and regulatory compliance.",
    image: "/assets/images/headerimg.png",
    path: "/citizen-wallet",
    gradient: "linear-gradient(135deg, #14532d 0%, #064e3b 100%)",
    shortTitle: "PPI Business"
  },
  {
    id: 2,
    title: "Payment Aggregation Services",
    subtitle: "High-Performance Aggregation",
    description: "Drive merchant growth with secure transactions, wallet integrations, and real-time settlement.",
    image: "/assets/images/image (14).png",
    path: "/tapay",
    gradient: "linear-gradient(135deg, #1e3a8a 0%, #172554 100%)",
    shortTitle: "Payment Aggregation"
  },
  {
    id: 3,
    title: "BBPS Business",
    subtitle: "Enterprise Bill Payments",
    description: "Scalable bill payment processing across multiple categories with an RBI-compliant framework and automated reconciliation.",
    image: "/assets/images/bbpsimage2.png",
    path: "/bbps-services",
    gradient: "linear-gradient(135deg, #0f766e 0%, #042f2e 100%)",
    shortTitle: "BBPS Business"
  },
  {
    id: 4,
    title: "Onboarding Stack",
    subtitle: "Intelligent Client Automation",
    description: "Digitize KYC, automate verifications, and activate customers faster with a fully compliant onboarding ecosystem.",
    image: "assets/onboardingimg.png",
    path: "/onboarding-stack",
    gradient: "linear-gradient(135deg, #334155 0%, #0f172a 100%)",
    shortTitle: "Onboarding Stack"
  }
];

// const maintenanceNotice =
//   "Dear Merchant/Customer, The Payment Gateway system will be unavailable from 8th October 2026, 3:00 PM to 9th October 2026, 4:00 PM due to scheduled maintenance activities.";

const ExpandingHero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="expanding-hero-root">
      <style>
        {`
          .expanding-hero-root {
            padding: 20px 20px 40px 20px;
            font-family: 'Inter', -apple-system, sans-serif;
            overflow: hidden;
            background-color: transparent;
          }

          /* --- News Ticker --- */
          .news-ticker {
            display: flex;
            align-items: center;
            width: 100%;
            max-width: 1400px;
            margin: 0 auto 20px auto;
            height: 44px;
            background: #fff7ed;
            border: 1px solid #fed7aa;
            border-radius: 12px;
            overflow: hidden;
          }

          .news-ticker-label {
            flex-shrink: 0;
            height: 100%;
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0 18px;
            background: #ea580c;
            color: #ffffff;
            font-weight: 700;
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            white-space: nowrap;
          }

          .news-ticker-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #ffffff;
            animation: tickerPulse 1.2s infinite;
          }

          .news-ticker-track {
            flex: 1;
            overflow: hidden;
            position: relative;
          }

          .news-ticker-content {
            display: inline-flex;
            white-space: nowrap;
            animation: tickerScroll 30s linear infinite;
          }

          .news-ticker-content span {
            padding-right: 80px;
            color: #9a3412;
            font-weight: 600;
            font-size: 0.95rem;
          }

          .news-ticker:hover .news-ticker-content {
            animation-play-state: paused;
          }

          @keyframes tickerScroll {
            from { transform: translateX(0); }
            to   { transform: translateX(-50%); }
          }

          @keyframes tickerPulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }

          .gallery-container {
            display: flex;
            width: 100%;
            max-width: 1400px;
            height: 500px;
            gap: 16px;
            margin: 0 auto;
          }

          /* --- Main Panel Logic --- */
          .gallery-panel {
            position: relative;
            flex: 0.7;
            border-radius: 24px;
            overflow: hidden;
            cursor: pointer;
            transition: flex 0.8s cubic-bezier(0.25, 1, 0.3, 1), transform 0.3s ease;
            display: flex;
            background-size: cover;
          }

          .gallery-panel:hover:not(.active) {
            transform: translateY(-4px);
          }

          .gallery-panel.active {
            flex: 5;
            cursor: default;
          }

          /* --- Desktop Grid Layout (Text Left / Image Right) --- */
          .panel-grid {
            display: grid;
            grid-template-columns: 1.1fr 0.9fr;
            width: 100%;
            height: 100%;
            padding: 60px;
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.4s ease;
            z-index: 10;
          }

          .gallery-panel.active .panel-grid {
            opacity: 1;
            pointer-events: auto;
            transition-delay: 0.25s;
          }

          /* --- Left Side Content --- */
          .content-left {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }

          .content-left h4 {
            color: #4ade80;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            font-weight: 700;
            font-size: 0.85rem;
            margin: 0 0 12px 0;
          }

          .content-left h2 {
            font-size: clamp(1.8rem, 3vw, 2.8rem);
            color: #ffffff;
            font-weight: 800;
            line-height: 1.2;
            margin: 0 0 20px 0;
          }

          .content-left p {
            font-size: 1.05rem;
            color: rgba(255, 255, 255, 0.85);
            line-height: 1.6;
            margin: 0 0 32px 0;
            max-width: 90%;
          }

          /* --- Right Side Content --- */
          .content-right {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }

          .service-img {
            max-width: 100%;
            max-height: 85%;
            object-fit: contain;
            filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.35));
            transform: scale(0.95);
            transition: transform 0.8s cubic-bezier(0.25, 1, 0.3, 1);
          }

          .gallery-panel.active .service-img {
            transform: scale(1.05);
          }

          /* --- Action Button --- */
          .explore-btn {
            background: #ffffff;
            color: #0f172a;
            border: none;
            padding: 14px 28px;
            border-radius: 12px;
            font-weight: 700;
            font-size: 0.95rem;
            display: inline-flex;
            align-items: center;
            gap: 10px;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          }

          .explore-btn:hover {
            transform: translateX(4px);
            background: #f8fafc;
            color: #000000;
          }

          /* --- Vertical Text Layout for Collapsed Cards --- */
          .collapsed-title {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 5;
            transition: opacity 0.2s;
          }

          .collapsed-title span {
            transform: rotate(-90deg);
            white-space: nowrap;
            color: rgba(255, 255, 255, 0.65);
            font-weight: 700;
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 3px;
          }

          .gallery-panel.active .collapsed-title {
            opacity: 0;
            pointer-events: none;
          }

          /* ==========================================================================
             MOBILE & TABLET RESPONSIVE
             ========================================================================== */
          @media (max-width: 960px) {
            .expanding-hero-root {
              padding: 16px 16px 24px 16px;
            }

            .news-ticker {
              height: 40px;
              margin-bottom: 16px;
              border-radius: 10px;
            }

            .news-ticker-label {
              padding: 0 12px;
              font-size: 0.75rem;
            }

            .news-ticker-content span {
              font-size: 0.85rem;
            }

            .news-ticker-content {
              animation-duration: 22s;
            }

            .gallery-container {
              flex-direction: column;
              height: auto;
              gap: 12px;
            }

            .gallery-panel {
              flex: none !important;
              width: 100%;
              height: 72px;
              border-radius: 16px;
              transition: height 0.6s cubic-bezier(0.25, 1, 0.3, 1);
            }

            .gallery-panel.active {
              height: auto;
            }

            .collapsed-title {
              justify-content: flex-start;
              padding: 0 24px;
            }

            .collapsed-title span {
              transform: none;
              color: #ffffff;
              font-size: 1rem;
              letter-spacing: 1px;
            }

            .panel-grid {
              grid-template-columns: 1fr;
              padding: 32px 24px;
              gap: 24px;
            }

            .gallery-panel.active .panel-grid {
              display: flex;
              flex-direction: column;
            }

            .content-left {
              align-items: flex-start;
              text-align: left;
            }

            .content-left h4 {
              font-size: 0.8rem;
              margin-bottom: 8px;
            }

            .content-left h2 {
              font-size: 1.75rem;
              margin-bottom: 14px;
            }

            .content-left p {
              font-size: 0.95rem;
              max-width: 100%;
              margin-bottom: 24px;
              line-height: 1.5;
            }

            .explore-btn {
              width: 100%;
              justify-content: center;
              padding: 16px;
            }

            .content-right {
              margin-top: 8px;
              width: 100%;
            }

            .service-img {
              max-height: 180px;
              width: auto;
              transform: scale(1) !important;
            }
          }
        `}
      </style>

      {/* News Ticker - Right to Left */}
      {/* <div className="news-ticker">
        <div className="news-ticker-label">
          <span className="news-ticker-dot"></span>
          Notice
        </div>
        <div className="news-ticker-track">
          <div className="news-ticker-content">
            <span>{maintenanceNotice}</span>
            <span>{maintenanceNotice}</span>
          </div>
        </div>
      </div> */}

      <div className="gallery-container">
        {servicesData.map((service, index) => (
          <div
            key={service.id}
            className={`gallery-panel ${activeIndex === index ? "active" : ""}`}
            style={{ background: service.gradient }}
            onMouseEnter={() => {
              if (window.innerWidth > 960) setActiveIndex(index);
            }}
            onClick={() => {
              if (activeIndex !== index) {
                setActiveIndex(index);
              } else {
                navigate(service.path);
              }
            }}
          >
            {/* Displayed when card is NOT active */}
            <div className="collapsed-title">
              <span>{service.shortTitle}</span>
            </div>

            {/* Displayed when card IS active */}
            <div className="panel-grid">
              <div className="content-left">
                <h4>{service.subtitle}</h4>
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button
                  className="explore-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(service.path);
                  }}
                >
                  Get Started <FiArrowRight size={18} />
                </button>
              </div>

              <div className="content-right">
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-img"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpandingHero;